import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TableData } from "@shared/model/auction.model";
import { VehicleDTO } from "@shared/model/vehicle.model";

@Component({
	selector: "app-incorrect-vehicle-dialog",
	templateUrl: "./incorrect-vehicle-dialog.component.html",
	styleUrl: "./incorrect-vehicle-dialog.component.scss",
	standalone: false
})
export class IncorrectVehicleDialogComponent {
	vehicles: VehicleDTO[];

	defaultLimit = 30;
	defaultOffset = 0;
	tableData: TableData = {
		rowsOnPage: 10,
		orderBy: "dateCreate",
		sortOrder: "desc",
		offset: this.defaultOffset,
		limit: this.defaultLimit,
		col: 4
	};
	rowsOnPageSet = [10, 20, 30];

	constructor(
		public dialogRef: MatDialogRef<IncorrectVehicleDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: VehicleDTO[]
	) {
		this.vehicles = data;
	}
	close() {
		this.dialogRef.close();
	}
}